export default {
  getGuestOrders: state => state.orders,
  getTotalOrders: state => state.totalOrders,
  getCountFilters: state => Object.values(state.paramsSearch).filter(e => !!e).length,
  getPeriodFromFilters: state => (!(state.paramsSearch['order-date']) ? '' : state.paramsSearch['order-date'].replace('to', '-')),
  isHasDublicateOrder: state => !!(state.openOrders && state.openOrders.length > 0),
  getCountFiltersInCall: state => !state.paramsSearchForCalling ? 0 : Object.values(state.paramsSearchForCalling).filter(e => !!e).length,
  getPeriodFromFiltersInCall: state => {
    if(!state.paramsSearchForCalling)
      return ''
    return (!(state.paramsSearchForCalling['order-date']) ? '' : state.paramsSearchForCalling['order-date'].replace('to', '-'))
  },
}
